/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `ChipTheme*`'s.
 */
export type ChipTheme =
  | ChipThemeDefault
  | ChipThemeGrey
  | ChipThemeBlue
  | ChipThemeGreen
  | ChipThemePurple
  | ChipThemeRed
  | ChipThemePink;

/**
 * The Chip default type.
 */
export type ChipThemeDefault = typeof CHIP_THEME_DEFAULT;

/**
 * The Chip grey type.
 */
export type ChipThemeGrey = typeof CHIP_THEME_GREY;

/**
 * The Chip blue type.
 */
export type ChipThemeBlue = typeof CHIP_THEME_BLUE;

/**
 * The Chip green type.
 */
export type ChipThemeGreen = typeof CHIP_THEME_GREEN;

/**
 * The Chip purple type.
 */
export type ChipThemePurple = typeof CHIP_THEME_PURPLE;

/**
 * The Chip red type.
 */
export type ChipThemeRed = typeof CHIP_THEME_RED;

/**
 * The Chip pink type.
 */
export type ChipThemePink = typeof CHIP_THEME_PINK;

/**
 * The Chip default constant.
 */
export const CHIP_THEME_DEFAULT = `default`;

/**
 * The Chip grey constant.
 */
export const CHIP_THEME_GREY = `grey`;

/**
 * The Chip blue constant.
 */
export const CHIP_THEME_BLUE = `blue`;

/**
 * The Chip green constant.
 */
export const CHIP_THEME_GREEN = `green`;

/**
 * The Chip purple constant.
 */
export const CHIP_THEME_PURPLE = `purple`;

/**
 * The Chip red constant.
 */
export const CHIP_THEME_RED = `red`;

/**
 * The Chip pink constant.
 */
export const CHIP_THEME_PINK = `pink`;
